import { RefreshCw, Plus, Network } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  loading: boolean;
  onRefresh: () => void;
  onCreate?: () => void;
}

const BlockchainNetworkHeader = ({ loading, onRefresh, onCreate }: Props) => {
  return (
    <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
      <div>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
            <Network className="h-6 w-6 text-primary" />
          </div>

          <div>
            <h1 className="text-3xl font-bold tracking-tight">
              Blockchain Networks
            </h1>

            <p className="text-sm text-muted-foreground">
              Manage supported blockchain networks, infrastructure and
              operational settings.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <Button variant="outline" onClick={onRefresh} disabled={loading}>
          <RefreshCw
            className={`mr-2 h-4 w-4 ${loading ? "animate-spin" : ""}`}
          />
          Refresh
        </Button>

        <Button onClick={onCreate}>
          <Plus className="mr-2 h-4 w-4" />
          Add Network
        </Button>
      </div>
    </div>
  );
};

export default BlockchainNetworkHeader;
